import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '../components/sidebar/sidebar.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-admin',
  standalone: true,
  imports: [RouterOutlet, SidebarComponent],
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.scss',
})
export class AdminComponent {
  private spinner = inject(NgxSpinnerService);

  onRouteActivate(): void {
    this.spinner.hide('main');
  }

  onRouteDeactivate(): void {
    this.spinner.show('main');
  }
}
